/* Fuego & Fragancia — el resaltador del titular de ff-split.

   El trazo se pinta cuando la sección entra en pantalla, no al cargar: si se
   animara al cargar, en una sección que vive a media página el visitante solo
   vería el resultado y se perdería el gesto, que es lo único que aporta.

   Se deja de observar en cuanto se pinta. Es una animación de una vez, no un
   efecto que va y viene cada vez que se pasa por delante — repetirlo cansa. */
(() => {
  const marcas = document.querySelectorAll('.ff-split__mark');
  if (!marcas.length) return;

  const encender = (el) => el.classList.add('is-lit');

  /* Sin IntersectionObserver (navegadores viejos) se enciende y ya: mejor el
     resaltado sin animar que un texto que se queda a medias. Lo mismo para
     quien pide menos movimiento — ahí el CSS quita la transición, así que
     encenderlo aquí simplemente lo deja pintado. */
  if (!('IntersectionObserver' in window)) {
    marcas.forEach(encender);
    return;
  }

  const observador = new IntersectionObserver(
    (entradas) => {
      entradas.forEach((entrada) => {
        if (!entrada.isIntersecting) return;
        encender(entrada.target);
        observador.unobserve(entrada.target);
      });
    },
    /* Un poco más de medio elemento visible: así el trazo arranca cuando el
       titular ya se está leyendo, no cuando asoma por el borde. */
    { threshold: 0.55 }
  );

  marcas.forEach((m) => observador.observe(m));
})();
